'use strict';

var _ = require('lodash');
var React = require('react');

var Constants = require('../../../constants');
var Forms = require('../../../forms');

var isNode = typeof document === 'undefined';
if (!isNode) {
    require('./homepage-blog.scss');
}

var BlogEntry = React.createClass({
    render: function() {
        var entry     = this.props.entry;
        var type      = this.props.type;
        var swapImage = this.props.swapImage;
        const src = `https://media.strongproject.com/homepage-blog/${entry.wordpressID}-${type}.jpg`

        return (
            <a className='hp-blog-entry' href={entry.url} target='_blank'>
                {type == 'feature' ?
                    <div className='hp-blog-entry-featured'>
                        <picture>
                            <source srcSet={`${src}.webp`} type="image/webp"/>
                            <source srcSet={src} type="image/jpg"/>
                            <img src={src} width="514" height="235" alt='featured blog image' />
                        </picture>
                        <div className='hp-blog-entry-featured-label-background' />
                        <div className='hp-blog-entry-featured-label'>
                            Featured
                        </div>
                    </div>
                :
                    !swapImage
                        ? <picture>
                            <source srcSet={`${src}.webp`} type="image/webp"/>
                            <source srcSet={src} type="image/jpg"/>
                            <img src={src} width="244" height="225" alt='blog image' />
                        </picture>
                        : null
                }

                <div className='hp-blog-entry-captions'>
                    <div className='hp-blog-entry-captions-category'>
                        {entry.category.toUpperCase()}
                    </div>

                    <div className='hp-blog-entry-captions-title'>
                        {entry.title}
                    </div>

                    <div className='hp-blog-entry-captions-subtitle'>
                        {type == 'feature' ? entry.featureSubtitle
                                           : entry.regularSubtitle}
                    </div>
                </div>

                {swapImage
                    ? <picture>
                        <source srcSet={`${src}.webp`} type="image/webp"/>
                        <source srcSet={src} type="image/jpg"/>
                        <img src={src} width="244" height="225" alt='blog image'/>
                    </picture>
                    : null}
            </a>
        );
    },
});

var HomepageBlog = React.createClass({
    render: function() {
        if (Payload.extra.blog.length < 3)
            return null;

        var feat = Payload.extra.blog[0];
        var reg = _.slice(Payload.extra.blog, 1);
        return (
            <div className='hp-blog'>
                
                <div className='hp-blog-header'>
                    <h3 className='hp-blog-header-title'>
                    The Latest Trends in Business Furniture and Modern Office Design
                    </h3>
                </div>

                <div className='hp-blog-feature-block'>
                    <BlogEntry type='feature' entry={feat} />
                </div>
                <div className='hp-blog-regular-block'>
                    <BlogEntry type='regular' entry={reg[0]} />
                    <BlogEntry type='regular' entry={reg[1]} swapImage={true} />
                </div>

                <div className='hp-blog-footer'>
                    <Forms.Button label={Payload.text['homepage.blog.button']} link='/blog' external={true} targetBlank={true} />
                </div>
            </div>
        );
    },
});

module.exports = HomepageBlog;



// WEBPACK FOOTER //
// ./src/pages/content/homepage/homepage-blog.jsx